import { render, staticRenderFns } from "./ResetButton.vue?vue&type=template&id=1a1fb4b6&scoped=true"
import script from "./ResetButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResetButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ResetButton.vue?vue&type=style&index=0&id=1a1fb4b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1fb4b6",
  null
  
)

export default component.exports